<template>
  <div class="terminal-stamp-page">
    <main class="terminal-stamp-content">
      <button
        type="button"
        class="terminal-stamp-title"
        @click="openRateDialog()"
      >
        QR-Code Stamp
      </button>

      <v-autocomplete
        v-show="ShowRateList"
        v-model="SelectRate"
        :items="RateList"
        item-text="rateDetail"
        item-value="rateCode"
        :aria-label="$t('message.SelectRate')"
        required
        outlined
        dense
        hide-details
        class="terminal-stamp-rate"
      ></v-autocomplete>

      <v-btn
        :disabled="SelectRate == null || $terminalSession.state.expired"
        class="terminal-stamp-scan-action text-capitalize"
        @click="OpenCamera()"
      >
        {{ Status ? "หยุด Scan QR บัตรจอดรถ" : $t("message.StartToScan") }}
      </v-btn>

      <div class="terminal-stamp-camera">
        <terminal-qr-scanner
          v-if="Status && scanning && !$terminalSession.state.expired"
          :key="scannerKey"
          :constraints="qrConstraints"
          camera-only
          @decode="onDecode"
          @init="onInit"
        />
      </div>
    </main>

    <v-dialog
      v-model="RedemptionSuccessDialog"
      persistent
      width="947"
      content-class="redemption-success-dialog"
    >
      <v-card class="redemption-success-alert" flat>
        <v-card-title class="redemption-success-alert__timer">
          <v-progress-circular color="#c63b00" indeterminate size="32">
            <span style="color: #c63b00; font-size: 14px">{{ timerCount }}</span>
          </v-progress-circular>
        </v-card-title>
        <v-card-text class="redemption-success-alert__content">
          <div>
            
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="12" align="center">
                <h2 class="redemption-success-alert__title">
                  Redemption Success
                </h2>
              </v-col>
            </v-row>
            <v-row cols="12" xs="12" sm="12" md="12" justify="center">
              <v-col cols="12" md="12" align="center" class="white rounded-sm">
                <table
                  style="
                    border-collapse: collapse;
                    width: 100%;
                    font-size: 20px;
                  "
                >
                  <tr>
                    <td style="color: #14223c">Ticket No.</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TicketNoDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">DateTime</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DateTimeDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Time In</td>
                    <td style="text-align: right; color: #14223c">
                      {{ TimeInDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Duration</td>
                    <td style="text-align: right; color: #14223c">
                      {{ DurationDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">License</td>
                    <td style="text-align: right; color: #14223c">
                      {{ CarLicenseDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">Type</td>
                    <td style="text-align: right; color: #14223c">
                      {{ VehicleNameDisplay }}
                    </td>
                  </tr>
                  <tr>
                    <td style="color: #14223c">RateDetail</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td style="color: #14223c"></td>
                    <td style="text-align: right; color: #de7302">
                      <div>
                        {{
                          $t("message.RateDetailLang") == "ENG"
                            ? RateDetailENGDisplay.split("\r\n")[0]
                            : RateDetailDisplay.split("\r\n")[0]
                        }}
                      </div>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td style="color: #14223c">Total</td>
                    <td
                      style="text-align: right; color: #262223; font-size: 20px"
                    >
                      {{ numberWithCommas(TotalDisplay) }}
                      <span style="color: black; font-size: 16px"> Baht</span>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoginSetRateDialog" persistent width="350">
      <v-card class="rate-login-dialog">
        <v-card-title class="rate-login-dialog__header">
          <v-btn
            class="rate-login-dialog__close"
            @click="closeRateDialog()"
            icon
            aria-label="Close"
          >
            <v-icon color="white" size="30">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="rate-login-dialog__body">
          <v-text-field
            v-model="UsernameRate"
            placeholder="Username"
            aria-label="Username"
            type="text"
            autocomplete="username"
            outlined
            hide-details
            class="rate-login-dialog__field"
            @keyup.enter="LoginSetRatePermission"
          />
          <v-text-field
            v-model="PasswordRate"
            placeholder="Password"
            aria-label="Password"
            :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="ShowPassword ? 'text' : 'password'"
            autocomplete="current-password"
            outlined
            hide-details
            class="rate-login-dialog__field"
            @click:append="ShowPassword = !ShowPassword"
            @keyup.enter="LoginSetRatePermission"
          />
          <v-btn
            color="#231F20"
            class="rate-login-dialog__submit white--text"
            @click="LoginSetRatePermission()"
          >
            Log In
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import TerminalQrScanner from "@/components/TerminalQrScanner.vue";
export default {
  name: "TerminalStamp",
  components: {
    TerminalQrScanner,
  },
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      QRCodeData: "",
      id: null,
      Status: false,
      response: "",
      RateList: [],
      ShowRateList:
        localStorage.getItem("TerminalStamp_ShowRateList") !== "false",
      timerCount: 7,
      SelectRate: localStorage.getItem("TerminalStamp_SelectRate") || null,

      LogID: null,
      TerminalID: null,
      DatetimeIn: "",
      TicketNo: "",
      CarLicense: "",
      MemberType: null,
      CarType: null,
      TenantID: null,
      RateData: null,
      Remark: "",

      ResponseRedeem: [],
      TicketNoDisplay: "",
      DateTimeDisplay: "",
      TimeInDisplay: "",
      DurationDisplay: "",
      CarLicenseDisplay: "",
      VehicleNameDisplay: "",
      RateCodeStringDisplay: "",
      RateDetailDisplay: "",
      RateDetailENGDisplay: "",
      TotalDisplay: "",
      RedemptionSuccessDialog: false,

      LoginSetRateDialog: false,
      UsernameRate: "",
      PasswordRate: "",
      ShowPassword: false,

      qrConstraints: {
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      },
      scanning: false,
      decodeLock: false,
      scannerKey: 0,

      IdleTimer: null,
      IdleSeconds: 0,
      LimitTime: 20,

      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },

  computed: {
    isGiantScreen() {
      const bp = this.$vuetify.breakpoint;
      return bp.width >= 800 && bp.height >= 1100;
    },
    screenClass() {
      return this.isGiantScreen ? "giant-mode" : "";
    },
  },

  mounted() {
    let self = this;
    self.GetDataRateCodeTerminalStamp();
  },

  beforeDestroy() {
    this.clearIdleTimer();
  },

  watch: {
    "$terminalSession.state.expired"(expired) {
      if (!expired) return;
      this.clearIdleTimer();
      this.Status = false;
      this.scanning = false;
      this.RedemptionSuccessDialog = false;
    },
    SelectRate(value) {
      if (value) {
        localStorage.setItem("TerminalStamp_SelectRate", value);
      } else {
        localStorage.removeItem("TerminalStamp_SelectRate");
      }
    },

    ShowRateList(value) {
      localStorage.setItem("TerminalStamp_ShowRateList", value);
    },

    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            if (this.timerCount == 0) {
              this.RedemptionSuccessDialog = false;
              this.scanning = true;
              this.decodeLock = false;
              this.ClearDataRedemptionDisplay();
            }
          }, 1000);
        }
      },
      immediate: true,
    },
  },

  methods: {
    startIdleTimer() {
      this.clearIdleTimer();
      this.IdleSeconds = 0;

      this.IdleTimer = setInterval(() => {
        this.IdleSeconds++;
        if (this.IdleSeconds >= this.LimitTime) {
          this.stopCameraByIdle();
        }
      }, 1000);
    },

    resetIdleTimer() {
      this.IdleSeconds = 0;
    },

    clearIdleTimer() {
      if (this.IdleTimer) {
        clearInterval(this.IdleTimer);
        this.IdleTimer = null;
      }
    },

    stopCameraByIdle() {
      this.clearIdleTimer();

      this.Status = false;
      this.scanning = false;
      this.decodeLock = false;

      Swal.fire({
        icon: "info",
        text: "ไม่มีการทำรายการเป็นระยะเวลานาน กล้องถูกปิดอัตโนมัติ",
        timer: 4000,
        showConfirmButton: false,
      });
    },

    OpenCamera() {
      if (this.$terminalSession.state.expired) return;
      this.Status = !this.Status;
      if (this.Status) {
        this.startIdleTimer();
        this.scanning = false;
        this.$nextTick(() => {
          this.scannerKey++;
          this.decodeLock = false;
          this.scanning = true;
        });
      } else {
        this.clearIdleTimer();
        this.scanning = false;
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (e) {
        if (this.$terminalSession.state.expired) return;
        this.Status = false;
        this.scanning = false;
        this.decodeLock = false;
        this.clearIdleTimer();

        Swal.fire({
          icon: "error",
          title: "Camera Error",
          width: 600,
          text: `ไม่สามารถเปิดกล้องได้: ${e?.message || String(e)} กรุณาตรวจสอบ Camera permission และ HTTPS`,
        });
      }
    },

    resumeScan() {
      this.resetIdleTimer();
      this.scanning = false;
      this.$nextTick(() => {
        this.scannerKey++;
        this.decodeLock = false;
        this.scanning = true;
      });
    },

    ShowRateListStatus() {
      let self = this;
      self.ShowRateList = !self.ShowRateList;
      localStorage.setItem("TerminalStamp_ShowRateList", this.ShowRateList);
    },

    openRateDialog() {
      let self = this;
      self.UsernameRate = "";
      self.PasswordRate = "";
      self.LoginSetRateDialog = true;
    },

    closeRateDialog() {
      let self = this;
      self.UsernameRate = "";
      self.PasswordRate = "";
      self.LoginSetRateDialog = false;
    },

    LoginSetRatePermission() {
      let self = this;
      let temp = {
        username: self.UsernameRate,
        password: self.PasswordRate,
      };
      axios
        .post(`${self.url}Login/LoginSetRatePermission`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ShowRateListStatus();
            self.closeRateDialog();
          }
        })
        .catch(function (error) {
          if (error?.terminalSessionHandled) return;
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        });
    },

    async onDecode(result) {
      if (this.$terminalSession.state.expired) return;
      if (this.decodeLock) return;
      this.resetIdleTimer();
      this.decodeLock = true;
      this.scanning = false;
      this.QRCodeData = result;
      await this.$nextTick();
      await this.SearchParkingByQRCode(result);
    },

    GetDataRateCodeTerminalStamp() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        projectID: self.projectID,
      };
      axios
        .post(`${self.url}Redemption/GetDataRateCodeTerminalStamp`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
            const savedRate = localStorage.getItem("TerminalStamp_SelectRate");
            if (savedRate) {
              const exists = self.RateList.some(
                (x) => String(x.rateCode) === String(savedRate)
              );

              if (exists) {
                self.SelectRate = savedRate;
              } else {
                self.SelectRate = null;
                localStorage.removeItem("TerminalStamp_SelectRate");
              }
            }
          }
        })
        .catch(function (error) {
          if (error?.terminalSessionHandled) return;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    async BindingDataResponseAfterScan() {
      let self = this;
      if (self.response != "" && self.response != undefined) {
        if (self.response.length > 0 && self.response[0].status != "Fail") {
          self.LogID = self.response[0].logId;
          self.TerminalID = self.response[0].terminalInId;
          self.DatetimeIn = self.response[0].entryDateTime;
          self.MemberType = self.response[0].memberTypeId;
          self.CarType = self.response[0].vehicleTypeId;
          self.TicketNo = self.response[0].ticketNo;
          self.DateTime = new Date(
            self.response[0].entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TenantID = parseInt(localStorage.getItem("TenantID"));
          self.CarLicense = self.response[0].plateNo;
          self.VehicleName = self.response[0].vehicleTypeName;
          self.RateCodeString = self.response[0].rateCode;
          self.RateDetail = self.response[0].rateDetailTH;
          self.RateDetailENG = self.response[0].rateDetailEN;
          self.Total = self.response[0].total;
          await self.RedeemData();
        } else {
          Swal.fire({
            icon: "warning",
            width: 900,
            text: self.response[0].message,
          });
        }
      }
    },

    async SearchParkingByQRCode(data) {
      let self = this;
      self.LoadingDialog = true;
      self.QRCodeData = data;
      let temp = {
        LogCarparkID: data,
        LostCard: false,
        projectID: self.projectID,
      };
      await axios
        .post(`${self.url}Redemption/GetParkingDetailByQRCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.response = response.data.data;
            if (response.data.data.length > 0) {
              self.timerCount = 7;
              self.BindingDataResponseAfterScan();
            }
          } else {
            Swal.fire({
              icon: "warning",
              width: 900,
              text: response.data.message,
            });
          }
        })
        .catch(function (error) {
          if (error?.terminalSessionHandled) return;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
          self.resumeScan();
        });
    },

    async RedeemData() {
      let self = this;
      if (
        self.LogID == "" ||
        self.TerminalID == null ||
        self.DatetimeIn == "" ||
        self.TicketNo == "" ||
        self.CarLicense == "" ||
        self.MemberType == null ||
        self.CarType == null ||
        self.TenantID == null ||
        self.SelectRate == null
      ) {
        Swal.fire({
          icon: "warning",
          width: 600,
          text: "กรุณาตรวจสอบข้อมูลใหม่อีกครั้ง !",
        });
      } else {
        self.LoadingDialog = true;
        let temp = {
          LogCarparkID: self.LogID,
          TerminalID: self.TerminalID,
          DatetimeIn: self.DatetimeIn,
          RunningNumber: self.TicketNo,
          PlateNumber: self.CarLicense,
          MemberType: self.MemberType,
          CarType: self.CarType,
          TenantID: self.TenantID,
          RateCode: self.SelectRate,
          Remark: self.Remark,
          projectID: self.projectID,
        };
        await axios
          .post(`${self.url}Redemption/RedeemParking`, temp)
          .then(function (response) {
            if (response.data.status == 0) {
              self.ResponseRedeem = response.data.data;
              self.BindingDataResponse();
            }
          })
          .catch(function (error) {
            if (error?.terminalSessionHandled) return;
            const message =
              error?.response?.data?.message ||
              error?.message ||
              "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

            Swal.fire({
              icon: "warning",
              width: 900,
              text: message,
            });
          })
          .finally(() => {
            self.LoadingDialog = false;
          });
      }
    },

    ClearDataRedemptionDisplay() {
      let self = this;
      self.TicketNoDisplay = "";
      self.DateTimeDisplay = "";
      self.TimeInDisplay = "";
      self.DurationDisplay = "";
      self.CarLicenseDisplay = "";
      self.VehicleNameDisplay = "";
      self.RateCodeStringDisplay = "";
      self.RateDetailDisplay = "";
      self.RateDetailENGDisplay = "";
      self.TotalDisplay = "";
      self.LogID = null;
      self.TerminalID = null;
      self.DatetimeIn = "";
      self.TicketNo = "";
      self.CarLicense = "";
      self.MemberType = null;
      self.CarType = null;
      self.TenantID = null;
      self.RateData = null;
      self.Remark = "";
      self.scanning = true;
      self.decodeLock = false;
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    BindingDataResponse() {
      let self = this;
      if (self.ResponseRedeem != "" && self.ResponseRedeem != undefined) {
        if (self.ResponseRedeem.status != "Fail") {
          self.TicketNoDisplay = self.ResponseRedeem.ticketNo;
          self.DateTimeDisplay = new Date(
            self.ResponseRedeem.entryDateTime
          ).toLocaleDateString("en-us", {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
          self.TimeInDisplay =
            self.ResponseRedeem.entryDateTime.split(" ").length > 0
              ? self.ResponseRedeem.entryDateTime.split(" ")[1]
              : "";
          self.DurationDisplay =
            self.ResponseRedeem.parkHH +
            " hrs " +
            self.ResponseRedeem.parkMM +
            " mins";
          self.CarLicenseDisplay = self.ResponseRedeem.plateNo;
          self.VehicleNameDisplay = self.ResponseRedeem.vehicleTypeName;
          self.RateCodeStringDisplay = self.ResponseRedeem.rateCode;
          self.RateDetailDisplay = self.ResponseRedeem.rateDetailTH;
          self.RateDetailENGDisplay = self.ResponseRedeem.rateDetailEN;
          self.TotalDisplay = self.ResponseRedeem.total;
          self.RedemptionSuccessDialog = true;
          this.resetIdleTimer();
        }
      }
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-display: swap;
}

.rate-login-dialog {
  overflow: hidden;
  border-radius: 0 !important;
}

.rate-login-dialog__header {
  position: relative;
  height: 62px;
  padding: 0 !important;
  background: #231f20;
}

.rate-login-dialog__close {
  position: absolute !important;
  top: 11px;
  right: 10px;
}

.rate-login-dialog__body {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 40px 24px 40px !important;
}

.rate-login-dialog__field {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
}

.rate-login-dialog__field >>> .v-input__slot {
  min-height: 56px !important;
  padding: 0 22px !important;
  background: #ffffff !important;
  border-radius: 14px !important;
  box-shadow: 0 6px 8px rgba(35, 31, 32, 0.16);
}

.rate-login-dialog__field >>> fieldset {
  border-color: #403c3d !important;
}

.rate-login-dialog__field >>> input {
  color: #231f20 !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 18px;
}

.rate-login-dialog__field >>> input::placeholder {
  color: #777373;
  opacity: 1;
}

.rate-login-dialog__field >>> .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
}

.rate-login-dialog__field >>> .v-icon {
  color: #231f20 !important;
  font-size: 25px;
}

.rate-login-dialog__submit {
  width: 100%;
  height: 52px !important;
  margin-top: 16px;
  border-radius: 12px;
  box-shadow: 0 7px 9px rgba(35, 31, 32, 0.28) !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 17px !important;
  font-weight: 400;
  letter-spacing: 0.02em;
}

.terminal-stamp-page {
  min-height: calc(100vh - 158px);
  background: #ffffff;
}

.terminal-stamp-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 108px 32px 84px;
}

.terminal-stamp-title {
  padding: 0;
  color: #231f20;
  background: transparent;
  border: 0;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
  font-size: 38px;
  line-height: 1.2;
  letter-spacing: 0.02em;
  cursor: pointer;
}

.terminal-stamp-title:focus-visible {
  outline: 3px solid #126496;
  outline-offset: 6px;
}

.terminal-stamp-rate {
  width: min(100%, 1200px);
  margin-top: 76px;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
}

.terminal-stamp-rate >>> .v-input__slot {
  min-height: 62px !important;
  padding: 0 28px !important;
  background: #ffffff !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 12px rgba(35, 31, 32, 0.12);
}

.terminal-stamp-rate >>> fieldset {
  border-color: #231f20 !important;
}

.terminal-stamp-rate >>> input,
.terminal-stamp-rate >>> .v-select__selection {
  color: #231f20 !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 19px;
  line-height: 1.5 !important;
}

.terminal-stamp-rate >>> .v-select__slot {
  align-items: center;
  min-height: 60px;
}

.terminal-stamp-rate >>> .v-select__selection {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 4px 0;
  overflow: visible;
}

.terminal-stamp-rate >>> .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
}

.terminal-stamp-rate >>> .v-icon {
  color: #231f20 !important;
}

.terminal-stamp-scan-action {
  min-width: 210px !important;
  height: 42px !important;
  margin-top: 44px;
  border-radius: 22px;
  background: #231f20 !important;
  box-shadow: 0 8px 12px rgba(35, 31, 32, 0.32) !important;
  color: #ffffff !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 17px !important;
}

.terminal-stamp-scan-action:hover,
.terminal-stamp-scan-action:focus-visible {
  background: #403a3c !important;
}

.terminal-stamp-scan-action.v-btn--disabled {
  background: rgba(35, 31, 32, 0.38) !important;
  box-shadow: none !important;
  color: rgba(255, 255, 255, 0.78) !important;
}

.terminal-stamp-camera {
  width: min(100%, 800px);
  margin-top: 44px;
}

.terminal-stamp-camera >>> video,
.terminal-stamp-camera >>> canvas {
  max-width: 100%;
  height: auto !important;
}

>>> .redemption-success-dialog {
  overflow: hidden;
  border: 1px solid #777273;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(38, 34, 35, 0.22);
}

.redemption-success-alert {
  min-height: 390px;
  background: #ffffff !important;
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}

.redemption-success-alert >>> * {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}

.redemption-success-alert__timer {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 1;
  padding: 0 !important;
}

.redemption-success-alert__content {
  padding: 42px 48px !important;
  text-align: center;
}

.redemption-success-alert__icon {
  margin-bottom: 18px;
  color: #342e30 !important;
}

.redemption-success-alert__title {
  margin: 0 0 24px;
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 36px !important;
  font-weight: 400;
  line-height: 1.18;
  letter-spacing: 0.01em;
}

.redemption-success-alert table {
  color: #403b3c;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 24px !important;
}

.redemption-success-alert table td,
.redemption-success-alert table span {
  font-size: 24px !important;
}

@media (max-width: 959px) {
  .terminal-stamp-page {
    min-height: calc(100vh - 144px);
  }

  .terminal-stamp-content {
    padding: 72px 24px 64px;
  }

  .terminal-stamp-title {
    font-size: 34px;
  }

  .terminal-stamp-rate {
    margin-top: 52px;
  }

}

@media (max-width: 600px) {
  >>> .redemption-success-dialog {
    width: calc(100vw - 32px) !important;
    margin: 16px;
  }

  .redemption-success-alert {
    min-height: 360px;
  }

  .redemption-success-alert__content {
    padding: 42px 24px 32px !important;
  }

  .redemption-success-alert__icon {
    font-size: 68px !important;
  }

  .redemption-success-alert__title {
    font-size: 36px !important;
  }

  .terminal-stamp-content {
    padding: 48px 16px 48px;
  }

  .terminal-stamp-title {
    font-size: 30px;
  }

  .terminal-stamp-rate {
    margin-top: 40px;
  }

  .terminal-stamp-rate >>> .v-input__slot {
    min-height: 56px !important;
    padding: 0 18px !important;
  }

  .terminal-stamp-rate >>> input,
  .terminal-stamp-rate >>> .v-select__selection {
    font-size: 17px;
  }

  .terminal-stamp-scan-action {
    width: 100%;
    margin-top: 32px;
  }

  .terminal-stamp-camera {
    margin-top: 32px;
  }
}

.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
.centered-input-header >>> input {
  text-align: center;
  color: black;
}
.TitleCSS {
  font-size: 18px;
  font-weight: 300;
  color: black;
}
@font-face {
  font-family: "English";
  src: local("English"), url(../assets/Font/Kanit-Regular.ttf);
}
* >>> .v-data-table-header {
  background-color: #333333 !important;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}
.addUserTitle {
  font-size: 14px;
  font-weight: 300;
}
.input-border {
  border: 1px solid black;
  height: 35px;
  padding: 4px;
}
.validation-class {
  color: red;
  font-size: 12px;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.giant-mode {
  padding: 20px !important;
}

.giant-mode * {
  font-size: 26px !important;
}

.giant-mode p,
.giant-mode .title {
  font-size: 70px !important;
  font-weight: 700 !important;
  text-align: center !important;
}

.giant-mode .v-autocomplete .v-input__control {
  min-height: 95px !important;
}

.giant-mode .v-autocomplete .v-input__slot {
  height: 95px !important;
  padding: 10px 20px !important;
  font-size: 28px !important;
}

.giant-mode .v-autocomplete input {
  font-size: 30px !important;
}

.giant-mode .v-autocomplete .v-label {
  font-size: 24px !important;
}

.giant-mode .v-autocomplete .v-icon {
  font-size: 34px !important;
}

.giant-mode .v-menu__content {
  transform: scale(1.3) !important;
  transform-origin: top left !important;
}

.giant-mode .v-list-item__title {
  font-size: 28px !important;
  padding: 16px 0 !important;
}

.giant-mode .v-btn {
  height: 95px !important;
  width: 90% !important;
  font-size: 50px !important;
  font-weight: bold !important;
  border-width: 3px !important;
  margin-top: 20px;
}

.giant-mode .v-dialog .v-card {
  padding: 40px !important;
  border-radius: 20px !important;
}

.giant-mode .v-dialog p,
.giant-mode .v-dialog span,
.giant-mode .v-dialog td {
  font-size: 30px !important;
}

.giant-mode table {
  font-size: 30px !important;
}

.giant-mode table td {
  padding: 16px 0 !important;
}

.giant-mode .total-row {
  font-size: 38px !important;
  font-weight: bold !important;
  color: green !important;
}

.giant-mode .baht-text {
  font-size: 26px !important;
}

.giant-mode .v-progress-circular {
  transform: scale(1.9) !important;
}
</style>
